// Import saga helpers
import { call, put, all, takeLatest } from "redux-saga/effects";

//Import actionType
import { GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST } from "./actionType";

// Import action
import {
  getSingleJobPageInvoiceItemsListSuccess,
  getSingleJobPageInvoiceItemsListFailure,
} from "./action";

// Import API

import { getSingleJobPageInvoiceItemsListApiCall } from "../../helpers/fakebackend_helper";

// Get SINGLE JOB PAGE Invoice Items List
function* getSingleJobPageInvoiceItemsListSaga({ payload }) {
  try {
    const response = yield call(
      getSingleJobPageInvoiceItemsListApiCall,
      payload
    );
    yield put(getSingleJobPageInvoiceItemsListSuccess(response));
  } catch (error) {
    yield put(getSingleJobPageInvoiceItemsListFailure(error));
  }
}
//

function* watcherSingleJobPageInvoiceItemsListSaga() {
  yield takeLatest(
    GET_SINGLE_JOB_PAGE_INVOICE_ITEMS_LIST,
    getSingleJobPageInvoiceItemsListSaga
  );
}

// Export saga
export default function* InvoiceItems() {
  yield all([watcherSingleJobPageInvoiceItemsListSaga()]);
}
